const createDateString = (year, month) => {
  if (year && month) {
    return `${year}-${month}`;
  }
  return null;
};

export default createDateString;
